import videojs from 'video.js';

export default function generateSearchResult(text, time, type, index, player) {
    const localize = player.localize?.bind(player);
    const TIME_ARIA_LABEL = localize('%%0%% hours, %%1%% minutes, %%2%% seconds');
    const SEARCH_RESULTS_ARIA_LABEL = localize('Search result %%0%%.  %%1%%.  %%2%%');

    const container = document.createElement('div');
    const timeString = new Date(time * 1000).toISOString().substr(11, 8);
    const hoursMinutesSeconds = timeString.split(':').map(value => parseInt(value, 10));

    const timeAriaLabel = replacePlaceholders(TIME_ARIA_LABEL, ...hoursMinutesSeconds);
    const ariaLabel = replacePlaceholders(SEARCH_RESULTS_ARIA_LABEL, index + 1, timeAriaLabel, text);

    container.innerHTML = `<li data-time="${time}" class="mediasite-player__search-result-list-item" tabindex="0" role="button" aria-label="${ariaLabel}">
        <span>${text}</span>
        <small>${videojs.formatTime(time, 3600)}</small>
        <small>${type}</small>
    </li>`;
    return container.firstChild;
}

const replaceRegex = /%%\d*%%/;
function replacePlaceholders(templateString, ...rest) {
    return rest.reduce((previous, current) => (
        previous.replace(replaceRegex, current)
    ), templateString);
}
